/* eslint-disable react/prop-types */
import React from 'react';
// eslint-disable-next-line no-unused-vars
import { withRouter } from 'react-router';
import { motion } from 'framer-motion';
import Grid from '@material-ui/core/Grid';
import { Box } from '@material-ui/core';
import OfficeIAdressnImput from './OfficeAdressImput';
import ColorButtonPurple from './ColorButtonPurple.js';
import ColorButtonWhite from './ColorButtonWhite.js';
import ImageStep3 from './images/img_step3.svg';
import StepBar from './StepBar.js';
import CopyRight from './CopyRight.js';
import { Link } from 'react-router-dom';

class Step3 extends React.Component {
  handleToStep2 = () => {
    // eslint-disable-next-line react/prop-types
    this.props.history.push('/step2');
  };
  handleToStep4 = () => {
    // eslint-disable-next-line react/prop-types
    this.props.history.push('/step4');
  };

  render() {
    return (
      <div>
        <motion.div
          className="contents-inner"
          animate={{
            x: 0,
            opacity: 1,
          }}
          initial={{
            x: 100,
            opacity: 0,
          }}
          exit={{
            x: -100,
            opacity: 0,
          }}
          transition={{
            duration: 0.2,
          }}
        >
          <Box textAlign="center" paddingBottom={3}>
            <h2 className="question">次にリモート率(↔出社率)を入力ください</h2>
            <Box mx={1}>
              <p className="step_discription1">全社員を100%としておおよその割合を記入ください</p>
            </Box>
            <img width="25%" src={ImageStep3} />
          </Box>

          <Grid container alignItems="center" justify="center">
            <Grid item xs={3}>
              <OfficeIAdressnImput
                name="過去のオフィス"
                nameEN="Before covid-19"
                discript="covid-19以前のオフィス"
                dataName1="出社率"
                dataName2="リモートワーク率"
                handleNum1Change={(e) => this.props.handleKakoShushaChange(e)}
                handleNum2Change={(e) => this.props.handleKakoRemoteChange(e)}
                num1={this.props.data.kako_shusha}
                num2={this.props.data.kako_remote}
              />
            </Grid>
            <Grid item xs={3}>
              <OfficeIAdressnImput
                name="現在のオフィス"
                nameEN="Under covid-19"
                discript="covid-19影響下の現在のオフィス"
                dataName1="出社率"
                dataName2="リモートワーク率"
                handleNum1Change={(e) => this.props.handleNowShushaChange(e)}
                handleNum2Change={(e) => this.props.handleNowRemoteChange(e)}
                num1={this.props.data.now_shusha}
                num2={this.props.data.now_remote}
              />
            </Grid>
            <Grid item xs={3}>
              <OfficeIAdressnImput
                name="今後のオフィス"
                nameEN="New normal"
                discript="働き方を改革した今後のオフィス"
                dataName1="出社率"
                dataName2="リモートワーク率"
                handleNum1Change={(e) => this.props.handleNewShushaChange(e)}
                handleNum2Change={(e) => this.props.handleNewRemoteChange(e)}
                num1={this.props.data.new_shusha}
                num2={this.props.data.new_remote}
              />
            </Grid>
          </Grid>

          <Box paddingTop={2}>
            <Grid container justify="center">
              <Grid item xs={2}>
                <Box m={1} textAlign="right">
                  <ColorButtonWhite size="large" variant="outlined" component={Link} to="/step2">
                    BACK
                  </ColorButtonWhite>
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Box m={1} textAlign="left">
                  <ColorButtonPurple size="large" variant="outlined" component={Link} to="/step4">
                    NEXT
                  </ColorButtonPurple>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <StepBar step="step3" />
          <Box marginTop={1}>
            <CopyRight />
          </Box>
        </motion.div>
      </div>
    );
  }
}

export default Step3;
